/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from "./store/store";
import Task from "./views/Task";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: '/',
                    redirect: '/tasks/own',
                },
                {
                    path: '/dashboard',
                    name: 'dashboard',
                    component: () => import('./views/Dashboard.vue'),
                },
                {
                    path: '/task/:id',
                    name: 'task',
                    component: () => import('./views/Task/SingleTask.vue'),
                },
                {
                    path: '/tasks/own',
                    name: 'ownTasks',
                    component: () => import('./views/Tasks.vue'),
                    props:{taskList:0},
                },
                {
                    path: '/tasks/all',
                    name: 'allTasks',
                    component: () => import('./views/Tasks.vue'),
                    props:{taskList:1},
                },
                {
                    path: '/tasks/unassigned',
                    name: 'unassignedTasks',
                    component: () => import('./views/Tasks.vue'),
                    props:{taskList:2},
                },
                {
                    path: '/tasks/closed',
                    name: 'closedTasks',
                    component: () => import('./views/Tasks.vue'),
                    props:{taskList:3},
                },
                {
                    path: '/tasks/paused',
                    name: 'pausedTasks',
                    component: () => import('./views/Tasks.vue'),
                    props:{taskList:4},
                },
                {
                    path: '/projects/open',
                    name: 'projectsOpen',
                    component: () => import('./views/Projects/Projects.vue'),
                    props:{listType:'open'},
                },
                {
                    path: '/projects/own',
                    name: 'projectsOwn',
                    component: () => import('./views/Projects/Projects.vue'),
                    props:{listType:'own'},
                },
                {
                    path: '/tasks/waitingForConfirmation',
                    name: 'tasksWaitingForConfirmation',
                    component: () => import('./views/Tasks.vue'),
                    props:{taskList:5},
                    children: [
                        {path: ':id', component: Task, name: 'taskModalClosed'}
                    ]
                },
                {
                    path: '/projects/finished',
                    name: 'projectsFinished',
                    component: () => import('./views/Projects/Projects.vue'),
                    props:{listType:'finished'},
                },
                {
                    path: '/projects/all',
                    name: 'projectsAll',
                    component: () => import('./views/Projects/Projects.vue'),
                    props:{listType:'default'},
                },
                {
                    path: '/project/:id',
                    name: 'project',
                    component: () => import('./views/Projects/Project.vue'),
                },
                {
                    path: '/absenceCalendar',
                    name: 'absenceCalendar',
                    component: () => import('./views/Calendar/AbsenceCalendar.vue'),
                    meta:{permission: 1401}
                },
                {
                    path: '/onCallCalendar',
                    name: 'onCallCalendar',
                    component: () => import('./views/Calendar/OnCallCalendar.vue'),
                },
                {
                    path: '/business_trips',
                    name: 'businessTrips',
                    component: () => import('./views/BusinessTrips/BusinessTrips.vue'),
                },
                {
                    path: '/clients',
                    name: 'clients',
                    component: () => import('./views/Clients.vue'),
                    meta:{permission: 301}
                },
                {
                    path: '/client/:id',
                    name: 'client',
                    component: () => import('./views/Client/Client.vue'),
                    meta:{permission: 301}
                },
                {
                    path: '/invoicing/tasks',
                    name: 'invoicingTasks',
                    component: () => import('./views/Invoicing/InvoicingTasks.vue'),
                    meta:{permission: 1101}
                },
                {
                    path: '/invoicing/waiting',
                    name: 'invoicingWaiting',
                    component: () => import('./views/Invoicing/InvoicingList.vue'),
                    meta:{permission: 1101},
                    props:{invoiceList:'waiting'},
                },
                {
                    path: '/invoicing/done',
                    name: 'invoicingDone',
                    component: () => import('./views/Invoicing/InvoicingList.vue'),
                    meta:{permission: 1101},
                    props:{invoiceList:'done'},
                },
                {
                    path: '/invoices/:id',
                    name: 'invoice',
                    component: () => import('./views/Invoicing/Invoice.vue'),
                    meta:{permission: 1101}
                },
                {
                    path: '/invoicing/projects/waiting',
                    name: 'invoicingProjectsWaiting',
                    component: () => import('./views/Invoicing/Projects.vue'),
                    meta:{permission: 1101},
                    props:{projectList:'waiting'},
                },
                {
                    path: '/invoicing/projects/done',
                    name: 'invoicingProjectsDone',
                    component: () => import('./views/Invoicing/Projects.vue'),
                    meta:{permission: 1101},
                    props:{projectList:'finished'},
                },
                {
                    path: '/users',
                    name: 'users',
                    component: () => import('./views/Users.vue'),
                    meta:{permission: 401}
                },
                {
                    path: '/user/:id',
                    name: 'user',
                    component: () => import('./views/UserPage/User.vue'),
                    meta:{permission: 401}
                },
                {
                    path: '/profile',
                    name: 'profile',
                    component: () => import('./views/UserPage/OwnProfile.vue'),
                },
                {
                    path: '/profile/analytics',
                    name: 'own-analytics',
                    component: () => import('./views/UserPage/OwnAnalytics.vue'),
                },
                {
                    path: '/roles',
                    name: 'roles',
                    component: () => import('./views/Roles.vue'),
                    meta:{permission: 701}
                },
                {
                    path: '/registration_terminals',
                    name: 'registration_terminals',
                    component: () => import('./views/RegistrationTerminal/RegistrationTerminals.vue'),
                    meta:{permission: 2201}
                },
                {
                    path: '/workTypes',
                    name: 'workTypes',
                    component: () => import('./views/WorkTypes.vue'),
                    meta:{permission: 501}
                },
                {
                    path: '/userTypes',
                    name: 'userTypes',
                    component: () => import('./views/UserTypes.vue'),
                    meta:{permission: 601}
                },
                {
                    path: '/userType/:id',
                    name: 'userType',
                    component: () => import('./views/UserType/UserType.vue'),
                    meta:{permission: 601}
                },
                {
                    path: '/settings',
                    name: 'settings',
                    component: () => import('./views/Settings.vue'),
                    meta:{permission: 1001}
                },
                {
                    path: '/vehicles',
                    name: 'vehicles',
                    component: () => import('./views/Vehicles.vue'),
                },
                {
                    path: '/tags',
                    name: 'tags',
                    component: () => import('./views/Tags.vue'),
                    meta:{permission: 1501}
                },
                {
                    path: '/transportTypes',
                    name: 'transportTypes',
                    component: () => import('./views/TransportTypes.vue'),
                    meta:{permission: 901}
                },
                {
                    path: '/travel_order',
                    name: 'travelOrders',
                    component: () => import('./views/Transport/TravelOrders.vue'),
                    meta:{permission: 1201}
                },
                {
                    path: '/at_vehicles',
                    name: 'atVehicles',
                    component: () => import('./views/ArtificialTransport/Vehicles.vue'),
                    meta:{permission: 1601}
                },
                {
                    path: '/at_vehicle/:id',
                    name: 'atVehicle',
                    component: () => import('./views/ArtificialTransport/Vehicle.vue'),
                    meta:{permission: 1601}
                },
                {
                    path: '/at_vehicle/:vehicle_id/at_period/:id',
                    name: 'atPeriod',
                    component: () => import('./views/ArtificialTransport/Period.vue'),
                    meta:{permission: 1601}
                },
                {
                    path: '/a_travel_order/:id',
                    name: 'artificialTravelOrder',
                    component: () => import('./views/ArtificialTransport/TravelOrder.vue'),
                    meta:{permission: 1601}
                },
                {
                    path: '/travel_order/:id',
                    name: 'travelOrder',
                    component: () => import('./views/Transport/TravelOrder.vue'),
                    meta:{permission: 1201}
                },
                {
                    path: '/projectTemplates',
                    name: 'projectTemplates',
                    component: () => import('./views/Projects/ProjectTemplates.vue'),
                    meta:{permission: 204}
                },
                {
                    path: '/projectTemplate/:id',
                    name: 'projectTemplate',
                    component: () => import('./views/Projects/ProjectTemplate.vue'),
                    meta:{permission: 204}
                },
                {
                    path: '/projectOffers',
                    name: 'projectOffers',
                    component: () => import('./views/Projects/ProjectOffers.vue'),
                    meta:{permission: 208}
                },
                {
                    path: '/projectOffer/:id',
                    name: 'projectOffer',
                    component: () => import('./views/Projects/ProjectOffer.vue'),
                    meta:{permission: 208}
                },
                {
                    path: '/myOffers',
                    name: 'myOffers',
                    component: () => import('./views/Offers/OfferList.vue'),
                    meta:{permission: 1901},
                    props:{listType:'own'},
                },
                {
                    path: '/allOffers',
                    name: 'allOffers',
                    component: () => import('./views/Offers/OfferList.vue'),
                    meta:{permission: 1901},
                    props:{listType:'all'},
                },
                {
                    path: '/finishedOffers',
                    name: 'finishedOffers',
                    component: () => import('./views/Offers/OfferList.vue'),
                    meta:{permission: 1901},
                    props:{listType:'finished'},
                },
                {
                    path: '/archivedOffers',
                    name: 'archivedOffers',
                    component: () => import('./views/Offers/OfferList.vue'),
                    meta:{permission: 1901},
                    props:{listType:'archived'},
                },
                {
                    path: '/offersInMaking',
                    name: 'offersInMaking',
                    component: () => import('./views/Offers/OfferList.vue'),
                    meta:{permission: 1903},
                    props:{listType:'inMaking'},
                },
                {
                    path: '/approvedOffers',
                    name: 'approvedOffers',
                    component: () => import('./views/Offers/OfferList.vue'),
                    meta:{permission: 1903},
                    props:{listType:'approved'},
                },
                {
                    path: '/offer/:id',
                    name: 'offer',
                    component: () => import('./views/Offers/Offer.vue'),
                    meta:{permission: 1901}
                },
                {
                    path: '/myMeetings',
                    name: 'myMeetings',
                    component: () => import('./views/Meetings/MeetingList.vue'),
                    meta:{permission: 2001},
                    props:{listType:'own'},
                },
                {
                    path: '/plannedMeetings',
                    name: 'plannedMeetings',
                    component: () => import('./views/Meetings/MeetingList.vue'),
                    meta:{permission: 2001},
                    props:{listType:'open'},
                },
                {
                    path: '/finishedMeetings',
                    name: 'finishedMeetings',
                    component: () => import('./views/Meetings/MeetingList.vue'),
                    meta:{permission: 2001},
                    props:{listType:'finished'},
                },
                {
                    path: '/meeting/:id',
                    name: 'meeting',
                    component: () => import('./views/Meetings/Meeting.vue'),
                    meta:{permission: 2001}
                },
                {
                    path: '/company/openTasks',
                    name: 'openTasks',
                    component: () => import('./views/Company/OpenTasks.vue'),
                    meta:{permission: 1301}
                },
                {
                    path: '/company/clientTimeOverview',
                    name: 'clientTimeOverview',
                    component: () => import('./views/Company/ClientTimeOverview.vue'),
                    meta:{permission: 1303}
                },
                {
                    path: '/company/timeAnalytics',
                    name: 'timeAnalytics',
                    component: () => import('./views/Company/TimeAnalytics.vue'),
                    meta:{permission: 1304}
                },
                {
                    path: '/wiki',
                    name: 'wiki',
                    component: () => import('./views/Wiki.vue'),
                    meta:{permission: 2101},
                    props: {wikiURL: '/wiki'}
                },
                {
                    path: '/wiki_komerciala',
                    name: 'wikiKomerciala',
                    component: () => import('./views/Wiki.vue'),
                    meta:{permission: 2102},
                    props: {wikiURL: '/wiki_komerciala'}
                },
                {
                    path: '/wiki_board',
                    name: 'wikiBoard',
                    component: () => import('./views/Wiki.vue'),
                    meta:{permission: 2103},
                    props: {wikiURL: '/wiki_board'}
                },
                {
                    path: '/wiki_iso',
                    name: 'wikiISO',
                    component: () => import('./views/Wiki.vue'),
                    meta:{permission: 2104},
                    props: {wikiURL: '/wiki_iso'}
                },
                {
                    path: '/wiki_meetings',
                    name: 'wikiMeetings',
                    component: () => import('./views/Wiki.vue'),
                    meta:{permission: 2105},
                    props: {wikiURL: '/wiki_meetings'}
                },



            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
                {
                    path: '/login',
                    name: 'page-login',
                    component: () => import('@/views/pages/Login.vue')
                },
                {
                    path: '/confirmTask/:id',
                    name: 'confirm-task',
                    component: () => import('@/views/pages/ConfirmTask.vue')
                },
                {
                    path: '/declineTask/:id',
                    name: 'decline-task',
                    component: () => import('@/views/pages/DeclineTask.vue')
                },
                {
                    path: '/confirmMeeting/:id',
                    name: 'confirm-meeting',
                    component: () => import('@/views/pages/ConfirmMeeting.vue')
                },
                {
                    path: '/declineMeeting/:id',
                    name: 'decline-meeting',
                    component: () => import('@/views/pages/DeclineMeeting.vue')
                },
                {
                    path: '/confirmHandover/:id',
                    name: 'confirm-handover',
                    component: () => import('@/views/pages/ConfirmHandover.vue')
                },
                {
                    path: '/declineHandover/:id',
                    name: 'decline-handover',
                    component: () => import('@/views/pages/DeclineHandover.vue')
                },
                {
                    path: '/resetPass/:id',
                    name: 'reset-pass',
                    component: () => import('@/views/pages/ResetPassword.vue')
                },
                {
                    path: '/resetPass/',
                    name: 'reset-pass-start',
                    component: () => import('@/views/pages/RequestResetPassword.vue')
                },
                {
                    path: '/inTransit',
                    name: 'in-transit',
                    component: () => import('@/views/pages/InTransit.vue')
                },
                {
                    path: '/registration_terminal_page/:lang/:access_key',
                    name: 'registration_terminal_page',
                    component: () => import('@/views/RegistrationTerminal/RegistrationTerminal.vue')
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue')
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

router.beforeEach((to, from, next) => {

    if(to.path.includes("resetPass") || to.path.includes("declineTask") || to.path.includes("confirmTask") || to.path.includes("confirmHandover") || to.path.includes("declineHandover") || to.path.includes("registration_terminal_page") || to.path.includes("confirmMeeting") || to.path.includes("declineMeeting")) return next();

    if (!store.getters.loggedIn && to.path !== "/login") {
        return next('/login');
    }

    if(to.meta.permission && store.getters.userData){
        if(store.getters.permissions.includes(to.meta.permission)){
            return next();
        }else{
            return next(false);
        }
    }

    if(store.getters.transportStarted && to.path !== "/inTransit"){
        return next('/inTransit');
    }

    if(!store.getters.transportStarted && to.path === "/inTransit"){
        return next('/');
    }

    next();
});

export default router
